if (document.querySelector(".banner-type")) {
  const bannerType = document.querySelector(".banner-type"),
    bannerInitial = bannerType.querySelector(".banner-type__initial"),
    changeBanner = bannerType.querySelectorAll(".banner-type__li"),
    renderBanner = bannerType.querySelector(".banner-type__render");

  changeBanner.forEach((button) => {
    button.addEventListener("click", () => {
      let imageAtribute = button.getAttribute("data-image");
      let colorBg = button.getAttribute("data-color-bg");
      let imageWraper = renderBanner.querySelector("img");
      let dataClass = button.getAttribute("data-class"),
        textContent = renderBanner.querySelector("h3"),
        dataColor = button.getAttribute("data-color");
      if (dataClass === "left") {
        renderBanner.classList.add(dataClass);
        renderBanner.classList.remove("rigth");
      } else {
        renderBanner.classList.add(dataClass);
        renderBanner.classList.remove("left");
      }
      if (imageAtribute !== "reset") {
        bannerInitial.classList.add("isHidden");
        renderBanner.classList.add("isVisible");
        textContent.style.color = dataColor;
        textContent.innerText = button.innerText;
        imageWraper.src = imageAtribute;
        renderBanner.style.backgroundColor = colorBg;
      } else {
        bannerInitial.classList.remove("isHidden");
        renderBanner.classList.remove("isVisible");
        renderBanner.style.backgroundColor = "";
      }
    });
  });
}
